// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid--xM43B","container":"container--mX0CI","left":"left--RFrNI","right":"right--nqoOz"};
    if(module.hot) {
      // 1653630373930
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  